'use client';

import { c as _c } from "react/compiler-runtime";
import type { OptionTableFilter } from '@morpho-org/ui-v6/client';
import { TableFilter } from '@morpho-org/ui-v6/client';
import { Separator } from '@repo/ui';
import { isEqual } from 'lodash-es';
import { useId } from 'react';
import type { AssetItem } from '@/components/common/TableAdvancedFilters/AssetFilter';
import { AssetFilter } from '@/helpers/filter/table';
import type { FilterDefinition } from './assetFilter';
import { getAssetIdsByFilter } from './assetFilter';
export function useAssetTagSlot(t0) {
  const $ = _c(18);
  const {
    assets,
    selectedValues,
    filterDefinitions,
    onSelect
  } = t0;
  const id = useId();
  let t1;
  if ($[0] !== assets || $[1] !== onSelect) {
    t1 = filterDef => {
      onSelect(getAssetIdsByFilter(assets, filterDef));
    };
    $[0] = assets;
    $[1] = onSelect;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleTagChange = t1;
  let t2;
  if ($[3] !== assets || $[4] !== filterDefinitions || $[5] !== handleTagChange || $[6] !== selectedValues) {
    let t3;
    if ($[8] !== assets || $[9] !== handleTagChange || $[10] !== selectedValues) {
      t3 = filterDef_0 => {
        const matchingAssets = getAssetIdsByFilter(assets, filterDef_0);
        const isActive = !selectedValues.length && filterDef_0.value === AssetFilter.ALL ? true : matchingAssets.length > 0 && isEqual(new Set(matchingAssets), new Set(selectedValues));
        return {
          value: filterDef_0.value,
          label: filterDef_0.label,
          isActive,
          isDisabled: filterDef_0.value !== AssetFilter.ALL && matchingAssets.length === 0,
          action: () => handleTagChange(filterDef_0),
          tooltip: filterDef_0.tooltip
        };
      };
      $[8] = assets;
      $[9] = handleTagChange;
      $[10] = selectedValues;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t2 = filterDefinitions.map(t3);
    $[3] = assets;
    $[4] = filterDefinitions;
    $[5] = handleTagChange;
    $[6] = selectedValues;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const tagOptions = t2;
  let t3;
  if ($[12] !== id || $[13] !== tagOptions) {
    t3 = <div className="px-sm py-xs"><TableFilter id={id} options={tagOptions} /></div>;
    $[12] = id;
    $[13] = tagOptions;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Separator />;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t3) {
    t5 = <>{t3}{t4}</>;
    $[16] = t3;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}